import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/result-archive-policy.ts
const resultArchiveModeSchema = z$1.enum([
	"none",
	"space_reply_only",
	"all_final_results"
]);
const resultArchivePolicySchema = z$1.strictObject({ mode: resultArchiveModeSchema });
//#endregion
export { resultArchiveModeSchema, resultArchivePolicySchema };

//# sourceMappingURL=result-archive-policy.js.map